import _ from 'lodash';
import { Component, ReactNode, CSSProperties } from 'react';
import './Tabs.less';
import SwipeableViews from 'react-swipeable-views';
// ------------------------------------------------------------------------------------------------
interface TabsProps {
    items: TabItem[];
    style?: CSSProperties;
    inkBarHeight?: number;
    inkBarColor?: string;
    selectedTabKey?: string | number;
    disableTouchEvents?: boolean;
    enableMouseEvents?: boolean;
    onTabChange?: (tabKey: string | number, tabIndex: number) => void;
}
// ------------------------------------------------------------------------------------------------
export interface TabItem {
    key: string | number;
    icon?: ReactNode;
    label: ReactNode;
    style?: CSSProperties;
    content: ReactNode;
    disabled?: boolean;
}
// ------------------------------------------------------------------------------------------------
interface TabsState {
    selectedTabIndex: number;
}
// ------------------------------------------------------------------------------------------------
export default class Tabs extends Component<TabsProps, TabsState> {
    // --------------------------------------------------------------------------------------------
    constructor(props: TabsProps) {
        super(props);

        this.state = {
            selectedTabIndex: this.getSelectedTabIndex()
        };
    }
    // --------------------------------------------------------------------------------------------
    componentDidUpdate(prevProps: Readonly<TabsProps>): void {
        if (this.props.selectedTabKey != prevProps.selectedTabKey &&
            this.props.selectedTabKey != null)
            this.setState({ selectedTabIndex: this.getSelectedTabIndex() });
    }
    // --------------------------------------------------------------------------------------------
    getSelectedTabIndex = () => {
        let selectedTabIndex = 0;
        if (this.props.selectedTabKey != null) {
            selectedTabIndex = _.findIndex(this.props.items, x => x.key == this.props.selectedTabKey);
            if (selectedTabIndex == -1)
                selectedTabIndex = 0;
        }
        return selectedTabIndex;
    }
    // --------------------------------------------------------------------------------------------
    render(): ReactNode {
        let selectedTab = this.props.items[this.state.selectedTabIndex];
        return (
            <div className='primitive-tabs'>
                {/* header */}
                <div
                    className='tabs-header'
                    style={{
                        display: 'flex',
                        ...this.props.style
                    }}>
                    {_.map(this.props.items, (x, i) => {
                        let isActiveTab = this.state.selectedTabIndex == i;
                        return <div
                            className={isActiveTab ? 'active' : undefined}
                            key={x.key?.toString()}
                            onClick={() => {
                                if (x.disabled) return;
                                this.setState({ selectedTabIndex: i });
                                if (_.isFunction(this.props.onTabChange))
                                    this.props.onTabChange(x.key, i);
                            }}
                            style={{
                                width: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                textAlign: 'center',
                                textTransform: 'uppercase',
                                textDecoration: 'none',
                                opacity: x.disabled ? 0.5 : 1,
                                cursor: x.disabled ? 'not-allowed' : 'pointer',
                                borderBottomStyle: isActiveTab ? 'solid' : undefined,
                                borderBottomColor: isActiveTab ? (this.props.inkBarColor ?? '#ff4081') : undefined,
                                borderBottomWidth: isActiveTab ? (this.props.inkBarHeight ?? 3) : undefined,
                                ...this.props.style,
                                ...x.style
                            }}>
                            {x.icon}
                            {x.label}
                        </div>;
                    })}
                </div>
                {/* content */}
                <div className='tabs-content'>
                    {<SwipeableViews
                        disabled={this.props.disableTouchEvents}
                        enableMouseEvents={this.props.enableMouseEvents}
                        onChangeIndex={index => this.setState({ selectedTabIndex: index })}>
                        {selectedTab?.content}
                    </SwipeableViews>}
                </div>
            </div>
        );
    }
}
// ------------------------------------------------------------------------------------------------